/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="./moverTool.controller.ts" />

module Meevo.Plugins.AddOnGroup {
    'use strict';

    export class AddOnGroupMoverTool implements angular.IDirective {
        restrict = 'E';
        templateUrl = 'app/plugins/addOnGroup/moverTool/moverTool.template.html';
        scope = {
            isReadonly: '=',
            excludeList: '=',
            criteria: '=',
            serviceCategoriesData: '=serviceCategories',
            servicesData: '=services',
            changed: "=?change",
            required: "=?ngRequired",
            tabIndex: '=?'
        };
        bindToController = true;
        controller = Meevo.Plugins.AddOnGroup.AddOnGroupMoverToolController;
        controllerAs = '$ctrl';
        require = [
            'addOnGroupMoverTool',
            'ngModel'
        ];
        link = (scope: any, element: JQuery, attr: angular.IAttributes, [self, ngModel]) => {
            self.ngModel = ngModel;
            self.init();
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new AddOnGroupMoverTool();
            };

            return directive;
        }
    }
    angular.module('meevo.plugins.addOnGroup')
        .directive('addOnGroupMoverTool', AddOnGroupMoverTool.factory());
}
